// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__3gvFM","BreadTop":"BurgerIngredient__BreadTop__1PRVY","Seeds1":"BurgerIngredient__Seeds1__2fQIB","Seeds2":"BurgerIngredient__Seeds2__1I7ry","Meat":"BurgerIngredient__Meat__1M3fw","Cheese":"BurgerIngredient__Cheese__UbGhv","Salad":"BurgerIngredient__Salad__12boN","Bacon":"BurgerIngredient__Bacon__LqGsk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BurgerIngredient/BurgerIngredient.css
// module id = 124
// module chunks = 3